import styled from 'styled-components';

import { purpurFocus } from '@telialt/common-theme/src/mixins';
import { getPurpurBorder, getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const StyledLink = styled.a`
    border-radius: ${getPurpurBorder('radiusMd')};
    border: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('borderInteractivePrimary')};
    padding: ${getPurpurSpacing('100')} ${getPurpurSpacing('200')};
    outline: none;
    color: ${getPurpurColor('textInteractivePrimary')};
    text-decoration: none;
    transition: none;
    ${purpurFocus()};

    &:focus {
        text-decoration: none;
        transition: none;
    }

    &:hover {
        outline: ${getPurpurBorder('widthSm')} solid ${getPurpurColor('borderInteractivePrimaryHover')};
        outline-offset: -${getPurpurBorder('widthSm')};
        border-color: transparent;
        background-color: ${getPurpurColor('backgroundInteractiveTransparentHover')};
        color: ${getPurpurColor('textInteractivePrimaryHover')};
        text-decoration: none;
        transition: none;
    }

    &:active {
        outline: ${getPurpurBorder('widthXs')} solid ${getPurpurColor('borderInteractivePrimaryActive')};
        outline-offset: -${getPurpurBorder('widthXs')};
        border-color: transparent;
        background-color: ${getPurpurColor('backgroundInteractiveTransparentActive')};
        color: ${getPurpurColor('textInteractivePrimaryActive')};
        text-decoration: none;
        transition: none;
    }
`;
